/*
Item: Form to list scheduled data import - can be found in
Name: ImportList
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { Messages } from 'primereact/messages';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import { Card } from 'primereact/card';
import { InputMask } from 'primereact/inputmask';
import { StatusMap } from '../utils/statusUtils';
import { DropdownLabeled } from '../components/DropdownLabeled';
import { DateTimeUtils } from '../utils/DateTimeUtils';
import MessageService from '../service/MessageService';
import ExportTableDialog from '../components/dialogue/ExportTableDialog';
import JsonHelper from '../utils/statisticsUtils';

function convertToLocal(convertTime) {
  let d = '';
  if (convertTime) {
    // correct time to local
    const year = convertTime.substring(6, 10);
    const month = convertTime.substring(3, 5);
    const day = convertTime.substring(0, 2);
    const time = convertTime.substring(11, 19);
    const dateString = `${month} ${day} ${year} ${time} GMT`;
    const curr = Date.parse(dateString);
    d = new Date(curr);
  }
  return d;
}

const menuItems = [
  { label: 'Fehler', value: 'ERROR' },
  { label: 'Fertig', value: 'FINISHED' },
  { label: 'Wartet', value: 'QUEUED' },
  { label: 'Aktiv', value: 'ACTIVE' },
  { label: 'Bereit', value: 'REQUESTED' },
];

const links = [
  {
    '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
    type: 'USER',
    name: '',
    reference: null,
    id: -1,
    shortDescription: '',
    idList: [],
  },
];

function colorTemplate(rowData) {
  let statusColor;

  switch(rowData.status) {
    case "Fertig": 
      statusColor = 'green';
      break;
    case "Aktiv":
      statusColor = 'lightgreen';
      break;
    case "Wartet":
      statusColor = 'orange';
      break;
    case "Bereit": 
      statusColor = 'blue';
      break;
    default: 
      statusColor = 'red';
      break
  }

  return (
    <span style={{
      borderRadius: '4px', padding: '2px 4px', color: 'white', background: statusColor,
    }}
    >
      {rowData.status}
    </span>
  );
}

export default class ImportList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndexTab: 0,
      loading: false,
      // state for dataTable:
      jobData: [],
      tableData: {
        jobs: {
          first: 0,
          last: 0,
          totalRecords: 0,
        },
        downloads: {
          first: 0,
          last: 0,
          totalRecords: 0,
        },
      },
      // state for propertyDialog
      propertiesRestricted: true,
      propertiesVisible: false,
      name: '',
      user: '',
      status: '',
      /* priority: '', */
      properties: '',
      // state for protocolDialog
      protocolVisible: false,
      protocol: '',
      // state for loadingDialog
      loadingVisible: false,
      renameVisible: false,
      deleteVisible: false,
      nameValue: '',
    };

    this.messageService = new MessageService();
    this.onPage = this.onPage.bind(this);
    this.viewItemProperties = this.viewItemProperties.bind(this);
    this.handleCloseProperties = this.handleCloseProperties.bind(this);
    this.handleCloseProtocol = this.handleCloseProtocol.bind(this);
    this.footerPropertiesDialog = this.footerPropertiesDialog.bind(this);
    this.renderPropertiesSaveButton = this.renderPropertiesSaveButton.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.dateTimeUtils = new DateTimeUtils();
  }

  componentDidMount = () => this.loadJobList(); // onLoad read current data

  // invoked after "Speichern" in properties window
  async handleUpdate() {
    // set message values from form
    const { properties, status } = this.state;
    let { startDateTime, endDateTime } = this.state;

    if (startDateTime === null) {
      startDateTime = '';
    } else if (!startDateTime.length) {
      startDateTime = `${this.dateTimeUtils.convertDate(startDateTime)} ${this.dateTimeUtils.convertTime(startDateTime)}`;
    }
    if (endDateTime === null) {
      endDateTime = '';
    } else if (!endDateTime.length) {
      endDateTime = `${this.dateTimeUtils.convertDate(endDateTime)} ${this.dateTimeUtils.convertTime(endDateTime)}`;
    }

    // set values
    properties.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].startTime = startDateTime;
    properties.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].endTime = endDateTime;
    properties.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].status = status;
    this.setState({ properties });
    const ret = await this.messageService.postJobUpdate(properties);
    if (ret[1]) {
      this.messages.show({
        life: 5000, severity: ret[1], summary: 'Hinweis:', detail: ret[0],
      });
    } else {
      this.messages.show({
        life: 5000, severity: 'success', summary: 'Hinweis:', detail: 'Der Auftrag wurde erfolgreich gespeichert.',
      });
    }
  }

  handleCloseProperties() {
    this.messages.clear();
    // this.loadJobList();
    this.setState({ propertiesVisible: false });
  }

  handleCloseProtocol() {
    this.setState({ protocolVisible: false });
  }

  async onPage(event, tableName) {
    console.log('ONPAGE#0', event);
    this.setState({ loading: true });
    const { tableData } = this.state;
    const { page, rows, pagecount } = event;
    const first = parseInt(event.first, 10);
    const result = '';
    const direction = 'TOP';
    const entries = null;
    const maxRowsPerPage = rows;
    const scrolling = false;
    const searchText = result;
    const sortDirection = 'DESC';
    let validPages;
    let potentialSelectionEntrySize;
    let type;
    let objtype;
    let object;
    let name;
    let sortCriterion;
    if (tableName === 'downloads') { // Tabelle
      type = 'resultTableRetrieval';
      objtype = 'TABLE';
      object = 56;
      name = 'Fachschlüssel';
      sortCriterion = 'Erstelldatum';
    } else {
      // Aufträge
      type = 'job';
      objtype = 'BATCHJOB';
      object = 505;
      name = 'Zeitpunkt';
      sortCriterion = 'Zeitpunkt';
    }
    const obj = {
      exactSearch: true,
      readingDirection: direction,
      entries,
      maxRowsPerPage,
      scrolling,
      sortCriterion,
      sortDirection,
      searchCriterion: name,
      searchText,
      objtype,
      object,
      page: page + 1,
      type,
    };
    let pageData;
    pageData = await this.messageService.postPageDirectory(obj);
    const jobs = pageData.entrys;
    validPages = pageData.viewSpecification.validPages;
    potentialSelectionEntrySize = pageData.viewSpecification.potentialSelectionEntrySize;
    tableData[tableName].validPages = validPages;
    tableData[tableName].rows = maxRowsPerPage;
    tableData[tableName].totalRecords = potentialSelectionEntrySize;
    tableData[tableName].page = page;
    tableData[tableName].first = first;
    tableData[tableName].last = first + jobs.length - 1;
    tableData[tableName].pagecount = pagecount;
    let data;
    if (tableName === 'downloads') {
      data = jobs.map((item) => {
        // const tmp = 1;
        const createdTime = item.createdDatabaseTime;
        const createdDateOnly = createdTime.split(' ')[0];
        const createdTimeOnly = createdTime.split(' ')[1];
        return {
          createdTime,
          createdDateOnly,
          createdTimeOnly,
          id: item.id,
          name: item.name,
          user: item.ownerInfo.user,
          item,
        };
      }, this);
      tableData[tableName].data = data;
    } else {
      data = jobs.map((item) => {
        const dStart = convertToLocal(item.startTime);
        const sortDate = dStart.toLocaleDateString('zh-Hans-CN');
        const createdTime = item.createdDatabaseTime;
        const createdDateOnly = createdTime.split(' ')[0];
        const createdTimeOnly = createdTime.split(' ')[1];
        return {
          createdTime,
          createdDateOnly,
          createdTimeOnly,
          item,
          id: item.id,
          name: item.name,
          user: item.ownerInfo.user,
          startDateSort: sortDate,
          startDate: item.startTime.substring(0, 10),
          startTime: item.startTime.substring(11, 19),
          startDateTime: item.startTime,
          endDateTime: item.endTime,
          modifiedDateTime: item.modifiedDatabaseTime,
          status: StatusMap[item.status],
          priority: item.priority,
          protocol: '',
        };
      }, this);
    }
    tableData[tableName].data = data;
    this.setState({
      loading: false,
      tableData,
    });
  }

  // opens the property dialog on click into list row
  async viewItemProperties(item) {
    this.messages.clear();
    // fill fields before loading
    this.setState({
      propertiesVisible: true,
      name: item.name,
      user: item.user,
      startDateTime: item.startDateTime,
      endDateTime: item.endDateTime,
      modifiedDateTime: item.modifiedDateTime,
    });
    // load property data
    const ret = await this.loadJobProperties(item.id);
    let pro = '';
    // only for returned errors as array
    if (ret[1]) {
      this.setState({ propertiesRestricted: false });
      this.messages.show({
        life: 5000, severity: ret[1], summary: 'Hinweis:', detail: ret[0],
      });
    } else {
      this.setState({ propertiesRestricted: true });
      // this.setState({
      // endTime:
      // ret.contents['genesis.container.content.GenesisTMContent']
      // .transfermodel.entrys[0].endTime });
      if (ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].protocol) {
        if (ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].protocol.langText[0].sprachKennzeichen === 'de') {
          pro = ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].protocol.langText[0].text;
        } else {
          pro = ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].protocol.langText[1].text;
        }
      }
      ret.contents['genesis.container.content.GenesisTMContent'].menuRoot = {};
      this.setState({
        protocol: pro,
        properties: ret,
        status: ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].status,
      });
    }
  }

  // function to load job list. Invoked in componentDidMount and each change of list
  async loadJobList() {
    let userLinks;
    const role = sessionStorage.getItem('role');
    const group = sessionStorage.getItem('group');
    const isAdmin = role === 'GROUP_ADMIN';
    const isSysAdmin = role === 'SYSTEM_ADMIN';
    const isSuperAdmin = role === 'SUPER_SUBJECT_ADMIN';
    const isStBA = group === 'StBA';
    if (!(isSysAdmin || isSuperAdmin || (isAdmin && isStBA))) {
      const userName = sessionStorage.getItem('username');
      userLinks = links;
      links[0].name = userName;
    }
    const { tableData } = this.state;
    let data;
    let jobData;
    try {
      this.setState({ loading: true });
      const result = '';
      const direction = 'TOP';
      const entries = null;
      const maxRowsPerPage = '10';
      const page = 1;
      const scrolling = false;
      const searchText = result;
      const sortDirection = 'DESC';
      let validPages;
      let potentialSelectionEntrySize;
      // Aufträge
      let type = 'job';
      let objtype = 'BATCHJOB';
      let object = 505;
      let name = 'Zeitpunkt';
      let sortCriterion = 'Zeitpunkt';
      let obj = {
        exactSearch: true,
        readingDirection: direction,
        entries,
        maxRowsPerPage,
        scrolling,
        sortCriterion,
        sortDirection,
        searchCriterion: name,
        searchText,
        objtype,
        object,
        page,
        type,
      };
      const listData1 = await this.messageService.postPageDirectory(obj);
      if (listData1.viewSpecification) {
        validPages = listData1.viewSpecification.validPages;
        potentialSelectionEntrySize = listData1.viewSpecification.potentialSelectionEntrySize;
        tableData.jobs.validPages = validPages;
        tableData.jobs.rows = maxRowsPerPage;
        tableData.jobs.totalRecords = potentialSelectionEntrySize;
        tableData.jobs.page = 0;
        tableData.jobs.first = 0;
        tableData.jobs.last = 9;
        data = listData1.entrys.map((item) => {
          const dStart = convertToLocal(item.startTime);
          const sortDate = dStart.toLocaleDateString('zh-Hans-CN');
          const createdTime = item.createdDatabaseTime;
          const createdDateOnly = createdTime.split(' ')[0];
          const createdTimeOnly = createdTime.split(' ')[1];
          return {
            createdTime,
            createdDateOnly,
            createdTimeOnly,
            item,
            id: item.id,
            name: item.name,
            user: item.ownerInfo.user,
            startDateSort: sortDate,
            startDate: item.startTime.substring(0, 10),
            startTime: item.startTime.substring(11, 19),
            startDateTime: item.startTime,
            endDateTime: item.endTime,
            modifiedDateTime: item.modifiedDatabaseTime,
            status: StatusMap[item.status],
            priority: item.priority,
            protocol: '',
          };
        }, this);
        tableData.jobs.data = data;
      }
      // Tabelle
      type = 'resultTableRetrieval';
      objtype = 'TABLE';
      object = 56;
      name = 'Fachschlüssel';
      sortCriterion = 'Erstelldatum';
      obj = {
        exactSearch: true,
        readingDirection: direction,
        entries,
        maxRowsPerPage,
        scrolling,
        sortCriterion,
        sortDirection,
        searchCriterion: name,
        searchText,
        objtype,
        object,
        page,
        type,
      };
      const pageData = await this.messageService.postPageDirectory(obj);
      const jobs = pageData.entrys;
      if (pageData.viewSpecification) {
        validPages = pageData.viewSpecification.validPages;
        potentialSelectionEntrySize = pageData.viewSpecification.potentialSelectionEntrySize;
        tableData.downloads.validPages = validPages;
        tableData.downloads.rows = maxRowsPerPage;
        tableData.downloads.totalRecords = potentialSelectionEntrySize;
        tableData.downloads.page = 0;
        tableData.downloads.first = 0;
        tableData.downloads.last = 9;
        tableData.downloads.pageData = pageData;
        jobData = jobs.map((item) => {
          // const tmp = 1;
          const createdTime = item.createdDatabaseTime;
          const createdDateOnly = createdTime.split(' ')[0];
          const createdTimeOnly = createdTime.split(' ')[1];
          return {
            createdTime,
            createdDateOnly,
            createdTimeOnly,
            id: item.id,
            name: item.name,
            user: item.ownerInfo.user,
            item,
          };
        }, this);
        tableData.downloads.data = jobData;
      }
    } catch (err) {
      console.log('error in loadJobList', err);
      this.setState({
        loading: false,
      });
    } finally {
      this.setState({
        loading: false,
        tableData,
      });
    }
  }

  async loadJobProperties(returnMessage) {
    const ret = await this.messageService.postProperties(returnMessage);
    return ret;
  }

  footerPropertiesDialog() {
    return (
      <div>
        {/* <Button
          label="Hilfe"
          disabled
          id="yes"
          type="button"
          icon="pi pi-md-help-outline"
          onClick={this.handleHelp}
        /> */ }
        {this.renderPropertiesSaveButton()}
        <Button
          label="Schließen"
          id="close"
          type="button"
          icon="pi pi-times"
          onClick={this.handleCloseProperties}
          className="p-button-danger"
        />
      </div>
    );
  }

  footerProtocolDialog() {
    return (
      <div>
        <Button
          label="Schließen"
          id="close"
          type="button"
          icon="pi pi-times"
          onClick={this.handleCloseProtocol}
          className="p-button-danger"
        />
      </div>
    );
  }

  footerDeleteDialog() {
    return (
      <div>
        <Button
          label="Löschen"
          id="close"
          type="button"
          icon="pi pi-check"
          onClick={() => this.handleDoFunktion('delete')}
          className="p-button-success"
        />
        <Button
          label="Schließen"
          id="close"
          type="button"
          icon="pi pi-times"
          onClick={() => this.setState({ deleteVisible: false })}
          className="p-button-danger"
        />
      </div>
    );
  }

  footerRenameDialog() {
    return (
      <div>
        <Button
          label="Umbenennen"
          id="close"
          type="button"
          icon="pi pi-check"
          onClick={() => this.handleDoFunktion('update')}
          className="p-button-success"
        />
        <Button
          label="Schließen"
          id="close"
          type="button"
          icon="pi pi-times"
          onClick={() => this.setState({ renameVisible: false })}
          className="p-button-danger"
        />
      </div>
    );
  }

  returnProperties() {
    const {
      status, name, user, startDateTime, endDateTime, modifiedDateTime,
    } = this.state;
    return (
      <div>
        <Messages ref={(el) => { this.messages = el; }} />
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-lg-12">
              <b>Auftrag</b>
            </div>
            <div className="p-col-12 p-lg-6">
              <span className="p-float-label">
                <InputText disabled id="in" defaultValue={name} />
                <label htmlFor="in">Typ</label>
              </span>
            </div>
            <div className="p-col-12 p-lg-3" />
            <div className="p-col-12 p-lg-3">
              <Button
                label="Protokoll"
                id="close"
                type="button"
                icon="pi pi-md-assignment"
                onClick={() => this.setState({ protocolVisible: true })}
                style={{ width: '12em' }}
              />
            </div>
            <div className="p-col-12 p-lg-6">
              <span className="p-float-label">
                <InputText disabled id="user" defaultValue={user} />
                <label htmlFor="user">Auftraggeber</label>
              </span>
            </div>
            <div className="p-col-12 p-lg-3" />
            {/* <div className="p-col-12 p-lg-3">
              {this.renderPropertiesDownloadButton()}
            </div> */}

            <div className="p-col-12 p-lg-6" />
          </div>
        </div>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-lg-6">
            <div className="card">
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-lg-12">
                  <b>Bearbeitungszeitraum</b>
                </div>
                <div className="p-col-12 p-lg-12">
                  <span className="p-float-label">
                    <InputMask id="startDateTime" mask="99.99.9999 99:99:99" value={startDateTime} onChange={(e) => this.setState({ startDateTime: e.value })} />
                    <label htmlFor="startDateTime">Früheste Startzeit</label>
                  </span>
                </div>
                <div className="p-col-12 p-lg-12">
                  <span className="p-float-label">
                    <InputMask id="endDateTime" mask="99.99.9999 99:99:99" value={endDateTime} onChange={(e) => this.setState({ endDateTime: e.value })} />
                    <label htmlFor="endDateTime">Späteste Startzeit</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="p-col-12 p-lg-6">
            <div className="card">
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-lg-12">
                  <b>Zustand</b>
                </div>
                <div className="p-col-12 p-lg-12">
                  <DropdownLabeled
                    id="status"
                    disabled={status === 'FINISHED'}
                    label="Status"
                    name="status"
                    options={menuItems}
                    value={status}
                    onChange={(e) => this.setState({ status: e.value })}
                    autoWidth={false}
                    tooltipOptions={{ event: 'focus' }}
                  />
                </div>
                <div className="p-col-12 p-lg-12">
                  <span className="p-float-label">
                    <InputText
                      disabled
                      id="in"
                      defaultValue={modifiedDateTime}
                    />
                    <label htmlFor="in">Letzte Änderung</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  returnProtocol() {
    const { protocol } = this.state;
    return (
      <div>
        <InputTextarea disabled style={{ opacity: '1', width: '100%', height: '400px' }} rows={5} cols={30} defaultValue={protocol} />
      </div>
    );
  }

  renderPropertiesSaveButton() {
    const { propertiesRestricted } = this.state;
    if (propertiesRestricted) {
      return (
        <Button
          label="Speichern"
          id="update"
          type="button"
          icon="pi pi-check"
          onClick={this.handleUpdate}
        />
      );
    }
    return <></>;
  }

  handleRename(obj) {
    const { name } = obj;
    this.setState({
      renameVisible: true,
      renameObject: obj,
      nameValue: name,
    });
  }

  handleDelete(obj) {
    const { name } = obj;
    this.setState({
      deleteVisible: true,
      renameObject: obj,
      nameValue: name,
    });
  }

  async handleDoFunktion(link) {
    const { nameValue, tableData, renameObject } = this.state;
    const jobData = JsonHelper.deepCopy(tableData.downloads.data);
    const { id, name } = renameObject;
    if (link === 'delete' || name !== nameValue) {
      for (let i = 0; i < jobData.length; i += 1) {
        if (id === jobData[i].id) {
          // read /resultTableRetrieval/propertiesCache for id, TABLE, 56
          const type = 'resultTableRetrieval';
          const path = 'properties';
          const obj = {
            object: '56',
            objectType: 'TABLE',
          };
          const propertiesSuccess = await this.messageService.postRuleProperties(path, type, name, id, obj);
          if (propertiesSuccess[1] !== 'error') {
            const { data } = propertiesSuccess;
            // do /resultTableRetrieval/update
            data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name = nameValue;
            data.contents['genesis.container.content.GenesisTMContent'].dispatchData.supplement = 1; // für Speichern
            const updateSuceess = await this.messageService.postRecordStructureUpdate(data, 'resultTableRetrieval', link);
            if (updateSuceess[1] !== 'error') {
              if (link === 'update') jobData[i].name = nameValue;
              if (link === 'delete') jobData.splice(i, 1);
            } else {
              this.growl.show({
                life: 12000, severity: updateSuceess[1], summary: 'Fehler', detail: updateSuceess[0][0].message,
              });
            }
          } else {
            this.growl.show({
              life: 12000, severity: propertiesSuccess[1], summary: 'Fehler', detail: propertiesSuccess[0][0].message,
            });
          }
        }
      }
    }
    tableData.downloads.data = jobData;
    this.setState({
      renameVisible: false,
      deleteVisible: false,
      tableData,
      // jobData,
    });
  }

  showExportTable(obj) {
    const { name } = obj;
    this.setState({
      exportTableVisible: true,
      valueStartStructure: obj,
      renameObject: obj,
      nameValue: name,
    });
  }

  onHideExportTable() {
    this.setState({ exportTableVisible: false });
  }

  async exportTable(option, nameInput) {
    const { tableData, renameObject } = this.state;
    const jobData = tableData.downloads.data;
    const { id, name } = renameObject;
    const link = 'retrievalCache';
    for (let i = 0; i < jobData.length; i += 1) {
      if (id === jobData[i].id) {
        // read /resultTableRetrieval/propertiesCache for id, TABLE, 56
        const type = 'resultTableRetrieval';
        const path = 'properties';
        const obj = {
          object: '56',
          objectType: 'TABLE',
          kriterium: [""],
        };
        this.growl.show({
          severity: 'info', summary: 'Tabelle Exportieren', detail: 'Download startet in Kürze.',
        });
        this.onHideExportTable();
        const propertiesSuccess = await this.messageService.postRuleProperties(path, type, name, id, obj);
        if (propertiesSuccess[1] !== 'error') {
          const { data } = propertiesSuccess;
          // do /resultTableRetrieval/update
          data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].name = name;
          data.contents['genesis.container.content.GenesisTMContent'].dispatchData.supplement = 1; // für Speichern
          const cacheSuccess = await this.messageService.postRecordStructureUpdate(data, 'resultTableRetrieval', link);
          if (cacheSuccess[1] !== 'error') {
            cacheSuccess.contents['genesis.container.content.GenesisTMContent'].parameter.hashMap.filename = [name];
            cacheSuccess.contents['genesis.container.content.GenesisTMContent'].transfermodel.exportsettings.resulttablesettings.chosenFormat = option;
            cacheSuccess.contents['genesis.container.content.GenesisTMContent'].transfermodel.renderer[0].sepQual = true; // ADBHSSTAT-1639
            const returnMessage = await this.messageService.postTableExport('resultTableRetrieval', cacheSuccess);
            if (returnMessage[1] === 'error') {
              this.growl.show({
                life: 12000, severity: returnMessage[1], summary: 'Fehler', detail: returnMessage[0][0].message,
              });
            } else {
              const returnMessageD = await this.messageService.postTableExportDownload('valueretrieval', returnMessage);
              // this.growl.show({ severity: 'info', summary: 'Tabelle Exportieren', detail: 'Export erfolgreich, Download startet in Kürze.' });
              const element = document.createElement('a');
              let fileType = '';
              let mimeType = '';
              let data1 = [returnMessageD[1]];
              const BOM = '\ufeff'; // for charset encoding, there has to be a better way
              if (option === 'CSV_TABLE') {
                fileType = '.csv';
                mimeType = 'text/csv;charset=utf-8';
                data1 = [BOM, returnMessageD[1]];
              } else if (option === 'XLSX') {
                fileType = '.xlsx';
                mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              } else if (option === 'FLATFILECSV_TABLE') {
                fileType = '.csv';
                mimeType = 'flatfile/csv;charset=utf-8'; // TODO 1889
                data1 = [BOM, returnMessageD[1]];
              } else {
                fileType = '.csv';
                mimeType = 'text/csv;charset=utf-8';
              }
              const file = new Blob(data1, { type: mimeType });
              element.href = URL.createObjectURL(file);
              element.download = nameInput + fileType;
              document.body.appendChild(element); // Required for this to work in FireFox
              element.click();
            }
          } else {
            this.growl.show({
              life: 12000, severity: propertiesSuccess[1], summary: 'Fehler', detail: propertiesSuccess[0][0].message,
            });
          }
        } else {
          this.growl.show({
            life: 12000, severity: propertiesSuccess[1], summary: 'Fehler', detail: propertiesSuccess[0][0].message,
          });
        }
      }
    }
  }

  actionTemplate(obj) {
    return (
      <div>
        <Button
          id="rename"
          tooltip="Tabelle umbenennen"
          onClick={() => this.handleRename(obj)}
          type="button"
          icon="pi-md-edit"
          className="p-button-info"
          style={{ marginRight: '.5em' }}
        />
        <Button
          id="export"
          tooltip="Tabelle exportieren"
          onClick={() => this.showExportTable(obj)}
          type="button"
          icon="pi pi-md-file-download"
          className="p-button-success"
        />
        <Button
          id="rename"
          tooltip="Tabelle löschen"
          onClick={() => this.handleDelete(obj)}
          type="button"
          icon="pi-md-delete-forever"
          className="p-button-danger"
          style={{ marginRight: '.5em' }}
        />
      </div>
    );
  }

  render() {
    const {
      loadingVisible, renameVisible, deleteVisible,
      propertiesVisible, protocolVisible,
      loading, properties, activeIndexTab,
      exportTableVisible, nameValue, tableData,
    } = this.state;
    const { jobs, downloads } = tableData;
    const jobsRows = jobs.rows ? parseInt(jobs.rows, 10) : 10;
    const jobsTotalRecords = jobs.totalRecords;
    const jobsFirst = jobs.first;
    const jobsLast = jobs.last;
    const jobsPageTemplate = `${jobsFirst + 1} bis ${jobsLast + 1} von ${jobsTotalRecords} Einträgen`;
    const jobsData = jobs.data;
    const downloadsRows = downloads.rows ? parseInt(downloads.rows, 10) : 10;
    const downloadsTotalRecords = downloads.totalRecords;
    const downloadsFirst = downloads.first;
    const downloadsLast = downloads.last;
    const downloadsPageTemplate = `${downloadsFirst + 1} bis ${downloadsLast + 1} von ${downloadsTotalRecords} Einträgen`;
    const downloadsData = downloads.data;
    let isJob = false;
    if (properties) {
      const atClass = properties.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0]['@class'];
      if (atClass === 'genesis.transfer.model.dto.JobDTO') isJob = true;
    }
    const headerText = isJob ? 'Batch-Werteabruf' : 'Auftragseigenschaften';
    const downloadsPaginatorLeft = (
      <Button
        icon="pi-md-refresh"
        onClick={() => this.onPage({
          first: downloadsFirst, rows: downloadsRows, page: 0, pagecount: 2,
        }, 'downloads')}
      />
    );
    // const pageTemplate = `${first} bis ${last} von ${totalRecords} Einträgen`;
    return (
      <Card style={{ height: '100%' }}>
        <Growl ref={(el) => { this.growl = el; }} />
        <ExportTableDialog
          exportTableVisible={exportTableVisible}
          onHideExportTable={this.onHideExportTable.bind(this)}
          exportTable={this.exportTable.bind(this)}
          nameValue={nameValue}
        />
        <Dialog
          header="Lade Daten..."
          closable={false}
          closeOnEscape={false}
          visible={loadingVisible}
          modal
          onHide={() => this.setState({ loadingVisible: false })}
        >
          <ProgressSpinner />
        </Dialog>
        <Dialog
          header="Tabelle löschen"
          footer={this.footerDeleteDialog()}
          closable
          style={{ width: '40vw' }}
          closeOnEscape
          visible={deleteVisible}
          modal
          onHide={() => this.setState({ deleteVisible: false })}
        >
          <p>
            Wollen Sie Die Tabelle {nameValue} wirklich löschen?
          </p>
        </Dialog>
        <Dialog
          header="Tabelle umbenennen"
          footer={this.footerRenameDialog()}
          closable
          style={{ width: '50vw' }}
          closeOnEscape
          visible={renameVisible}
          modal
          onHide={() => this.setState({ renameVisible: false })}
        >
          <div>
            <div className="card">
              <div className="p-grid p-fluid">
                <div className="p-col-2 p-lg-3">
                  <b>Tabelle</b>
                </div>
                <div className="p-col-2 p-lg-7">
                  <span className="p-float-label">
                    <InputText
                      style={{ width: '16rem' }}
                      maxLength="255"
                      id="name"
                      value={nameValue}
                      onChange={(e) => this.setState({ nameValue: e.target.value })}
                    />
                    <label htmlFor="name">Bezeichnung</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
        <Dialog
          header={headerText}
          footer={this.footerPropertiesDialog()}
          visible={propertiesVisible}
          closeOnEscape
          style={{ width: '50vw' }}
          modal
          onHide={() => this.setState({ propertiesVisible: false })}
        >
          {this.returnProperties()}
        </Dialog>

        <Dialog
          header="Protokoll"
          footer={this.footerProtocolDialog()}
          visible={protocolVisible}
          closeOnEscape
          style={{ width: '49vw' }}
          modal
          onHide={() => this.setState({ protocolVisible: false })}
        >
          {this.returnProtocol()}
        </Dialog>
        <TabView id="referenceDataTab" activeIndex={activeIndexTab} onTabChange={(e) => this.setState({ activeIndexTab: e.index })}>
          <TabPanel header="Aufträge">
            <DataTable
              selectionMode="single"
              onSelectionChange={(e) => this.viewItemProperties(e.value)}
              value={jobsData}
              paginator
              paginatorPosition="both"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rows={jobsRows}
              rowsPerPageOptions={[5, 10, 20, 30]}
              currentPageReportTemplate={jobsPageTemplate}
              totalRecords={jobsTotalRecords}
              lazy
              first={jobsFirst}
              onPage={(e) => this.onPage(e, 'jobs')}
              loading={loading}
              resizableColumns
            >
              <Column field="name" header="Auftragsart" style={{ width: '40%' }} />
              <Column field="user" header="Benutzer" style={{ width: '20%' }} />
              <Column field="startDate" header="Datum" style={{ width: '15%' }} />
              <Column field="startTime" header="Zeit" style={{ width: '15%' }} />
              <Column field="status" header="Status" body={colorTemplate} style={{ width: '10%' }} />
            </DataTable>
          </TabPanel>
          <TabPanel header="Tabellen zum Download">
            <DataTable
              selectionMode="single"
              value={downloadsData}
              paginator
              paginatorPosition="both"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rows={downloadsRows}
              rowsPerPageOptions={[5, 10, 20, 30]}
              currentPageReportTemplate={downloadsPageTemplate}
              totalRecords={downloadsTotalRecords || 0}
              lazy
              first={downloadsFirst}
              onPage={(e) => this.onPage(e, 'downloads')}
              loading={loading}
              resizableColumns
            >
              <Column field="name" header="Bezeichnung" style={{ width: '20%' }} />
              <Column field="user" header="Benutzer" style={{ width: '20%' }} />
              <Column field="createdDateOnly" header="Erstelldatum" style={{ width: '15%' }} />
              <Column field="createdTimeOnly" header="-zeit" style={{ width: '15%' }} />
              <Column header="Aktionen" body={(obj) => this.actionTemplate(obj)} style={{ textAlign: 'center', width: '6em' }} />
            </DataTable>
          </TabPanel>
        </TabView>
      </Card>
    );
  }
}
